<template>
  <el-dialog
    :title="popupConfig.title"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      v-loading="loading"
    >
      <el-form-item label="话术标题" prop="title">
        <el-input
          v-model="ruleForm.title"
          maxlength="50"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="一级分类" prop="oneClassId">
        <el-select
          size="mini"
          v-model="ruleForm.oneClassId"
          :placeholder="oneOptions.length > 0 ? '请选择' : '无数据'"
          v-loading="loading1"
          @change="(ruleForm.twoClassId = ''), getTwoClassData()"
        >
          <el-option
            v-for="item in oneOptions"
            :key="item.classId"
            :label="item.className"
            :value="item.classId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类" prop="twoClassId">
        <el-select
          size="mini"
          v-model="ruleForm.twoClassId"
          :placeholder="twoOptions.length > 0 ? '请选择' : '无数据'"
          v-loading="loading2"
        >
          <el-option
            v-for="item in twoOptions"
            :key="item.classId"
            :label="item.className"
            :value="item.classId"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="话术内容" prop="content">
        <MyUpload ref="myUploadRef" :myType="6" @receiveParam="receiveParam" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <!-- //保存  不重置  不关窗 -->
      <el-button type="primary" size="small" @click="submitForm('ruleForm')"
        >保 存
      </el-button>
      <!-- //保存  重置   不关窗   -->
      <el-button
        type="primary"
        v-if="!popupConfig.scriptId"
        size="small"
        @click="againAdd('ruleForm')"
        >再创建一条</el-button
      >
      <!-- <el-button type="primary" @click="submitForm('ruleForm')">完 成</el-button> //保存  关窗 -->
    </span>
  </el-dialog>
</template>
<script>
import {
  // getScript, 后端合并代码导致侧边栏接口和后台接口冲突，所以废弃
  getScriptAdmin,
  getTwoClass,
  getOneClass,
  editScript,
  addScript,
} from "@/api/sciptLibrary/index";

import MyUpload from "@/views/mass/SOP/components/myUpload.vue";
export default {
  components: {
    MyUpload,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    popupConfig: {
      type: Object,
      default: () => {
        return {
          title: "",
          scriptId: "",
        };
      },
    },
  },
  data() {
    return {
      loading: false,
      loading1: false,
      loading2: false,
      oneOptions: [],
      twoOptions: [],
      ruleForm: {
        title: "",
        oneClassId: "",
        twoClassId: "",
        content: "",
        resourceVoList: [],
        linkVoList: [],
      },
      rules: {
        title: [
          { required: true, message: "话术标题", trigger: "blur" },
          {
            min: 0,
            max: 50,
            message: "长度在 0 到 50 个字符",
            trigger: "blur",
          },
        ],
        oneClassId: [{ required: true, message: "请选择", trigger: "change" }],
        twoClassId: [{ required: true, message: "请选择", trigger: "change" }],
        content: [
          { required: true, message: "话术内容不能为空", trigger: "change" },
          { validator: this.validatePass, trigger: "change" },
        ],
        hasSave: false, //是否保存过  是 关窗后请求列表接口
      },
    };
  },
  watch: {
    popupConfig: {
      handler(newVal) {
        console.log("pop", this.popupConfig);
        if (newVal.scriptId.length > 0) {
          this.getPopupData();
        } else {
          this.getOneClassData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    validatePass(rule, value, callback) {
      console.log("校验空格", value.replace(/\s+/g, "").length);
      if (value.replace(/\s+/g, "").length <= 0) {
        callback(new Error("请输出内容，空格不计"));
      } else {
        callback();
      }
    },
    async getOneClassData() {
      // this.ruleForm.oneClassId = ""
      this.loading1 = true;
      let res = await getOneClass(true);
      if (res.error.code == 200 && res.data.length > 0) {
        this.oneOptions = res.data;
        // this.ruleForm.oneClassId = res.data[0].classId
      } else {
        this.oneOptions = [];
      }
      this.loading1 = false;

      if (this.ruleForm.oneClassId) {
        this.getTwoClassData();
      }
    },
    async getTwoClassData() {
      // this.ruleForm.twoClassId = ""
      if (this.ruleForm.oneClassId) {
        this.loading2 = true;
        let res = await getTwoClass(this.ruleForm.oneClassId, true);
        if (res.error.code == 200 && res.data.length > 0) {
          this.twoOptions = res.data;
          // this.ruleForm.twoClassId = res.data[0].classId
        } else {
          this.twoOptions = [];
        }
        this.loading2 = false;
      }
    },

    async getPopupData() {
      this.ruleForm.oneClassId = "";
      this.loading = true;
      // let res = await getScript(this.popupConfig.scriptId, true);
      let res = await getScriptAdmin(this.popupConfig.scriptId, true);
      console.log(66, res);
      if (res.error.code == 200) {
        const data = res.data;
        for (const key in data) {
          this.ruleForm[key] != undefined
            ? (this.ruleForm[key] = data[key])
            : "";
        }
        // 传递给父组件----
        res.data.content
          ? (this.ruleForm.content = res.data.content)
          : (this.ruleForm.content = "");
        res.data.resourceVoList
          ? (this.ruleForm.resourceVoList = res.data.resourceVoList)
          : (this.ruleForm.resourceVoList = []);
        res.data.linkVoList
          ? this.ruleForm.linkVoList.concat(res.data.linkVoList)
          : (this.ruleForm.linkVoList = []);
        console.log("-----------------xxxxx", this.ruleForm, "xxx", res.data);

        this.$refs.myUploadRef.content = res.data.content;

        data.resourceVoList = res.data.resourceVoList
          ? res.data.resourceVoList
          : [];
        console.log("res.data.resourceVoList+_", data.resourceVoList);
        console.log(
          "this.ruleForm.resourceVoListdsfsdfsdf",
          this.ruleForm.resourceVoList
        );
        data.resourceVoList.forEach((item) => {
          let obj = {
            url: item.url,
            name: item.resourceName,
            fileFullUrl: item.resourceUrl,
          };
          console.log("itemitemitemXXXX", item);
          if (
            item.resourceType == "doc" ||
            item.resourceType == "pdf" ||
            item.resourceType == "xls" ||
            item.resourceType == "xlsx"
          ) {
            this.$refs.myUploadRef.uploadFileList.push(obj);
          } else if (item.resourceType == "mp4" || item.resourceType == "Mp4") {
            this.$refs.myUploadRef.videoList.push(obj);
          } else {
            this.$refs.myUploadRef.photoList.push(obj);
          }
        });
        data.linkVoList = res.data.linkVoList ? res.data.linkVoList : [];
        data.linkVoList.forEach((item) => {
          let obj = {
            title: item.title,
            httpUrl: item.httpUrl,
            content: item.content,
            pictureUrl: item.pictureUrl,
            pictureName: item.pictureName,
            fileFullUrl: item.pictureUrl,
          };
          // 只能显示一条
          this.$refs.myUploadRef.linkList.push(obj);
          this.$refs.myUploadRef.myFormLink = obj;
        });

        this.getOneClassData();
        console.log(888, this.ruleForm, this.$refs.myUploadRef, res.data);
      } else {
        // this.oneOptions = []
      }
      this.loading = false;
    },

    // 接受上传组件返回的参数
    receiveParam(obj) {
      console.log("obj", obj);
      // obj.content
      //   ? (this.ruleForm.content = obj.content)
      //   : (this.ruleForm.content = "");
      // obj.resourceVos.length
      //   ? this.ruleForm.resourceVoList.concat(obj.resourceVos)
      //   : (this.ruleForm.resourceVoList = []);
      obj.linkVo
        ? this.ruleForm.linkVoList.push(obj.linkVo)
        : (this.ruleForm.linkVoList = []);
      if (obj.content) {
        this.ruleForm.content = obj.content;
      }
      if (obj.resourceVos.length > 0) {
        this.ruleForm.resourceVoList = obj.resourceVos;
      } else {
        if (this.ruleForm.resourceVoList.length <= 0) {
          this.ruleForm.resourceVoList = [];
        } else {
          this.ruleForm.resourceVoList = obj.resourceVos;
        }
      }
      console.log("数据更改XXXX", this.ruleForm);
    },

    //保存  不重置  不关窗  (编辑的时候关闭)
    submitForm(formName) {
      console.log(777, this.ruleForm, this.ruleForm.resourceVoList);

      // return
      console.log("this.ruleForm", this.ruleForm);
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          console.log(99, this.ruleForm);

          let res = "";
          if (this.popupConfig.scriptId) {
            res = await editScript(
              this.popupConfig.scriptId,
              this.ruleForm,
              true
            );
          } else {
            res = await addScript(this.ruleForm, true);
          }
          this.loading = false;
          if (res.error.code == 200) {
            this.hasSave = true;
            this.$message({
              type: "success",
              message: "保存成功",
            });

            this.handleClose();
          } else {
            // this.$message({
            //   type: "error",
            //   message: "保存失败",
            // });
          }
        } else {
          return false;
        }
      });
    },
    //再创建一条  重置
    againAdd(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          console.log(99, this.ruleForm);
          let res = "";
          if (this.popupConfig.scriptId) {
            res = await editScript(
              this.popupConfig.scriptId,
              this.ruleForm,
              true
            );
          } else {
            res = await addScript(this.ruleForm, true);
          }

          this.loading = false;
          console.log(66, res);
          if (res.error.code == 200) {
            this.hasSave = true;
            this.$message({
              type: "success",
              message: "保存成功",
            });

            this.$refs.myUploadRef.content = "";
            this.$refs.myUploadRef.photoList = [];
            this.$refs.myUploadRef.uploadFileList = [];
            this.$refs.myUploadRef.linkList = [];
            this.$refs.myUploadRef.myFormLink = {};
            this.twoOptions = [];
            this.$refs.ruleForm.resetFields();
            setTimeout(() => {
              console.log("this.ruleForm", this.ruleForm);
            }, 1000);
          } else {
            this.$message({
              type: "error",
              message: "保存失败",
            });
          }
        } else {
          return false;
        }
      });
    },

    handleClose() {
      this.$emit("update:dialogVisible", false);
      if (this.hasSave) {
        this.$emit("getData");
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
